import { FC } from 'react'

import styles from './grid.module.css'
import { GridProps } from './grid.type'


const Grid: FC<GridProps> = ({ children, className }) =>
    <div className={ `${styles.gridContainer} ${className}` }>
        { children }
    </div>

export default Grid  
